/**
 * Default rejection/decline reasons used as a fallback when the organization
 * has not configured custom referralRejectionReasons.
 *
 * Shared by RejectReferral and DeclineReferralModal.
 */
export const DEFAULT_REJECTION_REASONS: ReadonlyArray<{ key: string; value: string }> = [
  { key: 'Patient Declined Referral', value: 'patient_declined_referral' },
  { key: 'Patient Scheduled With Other Provider', value: 'patient_scheduled_with_other_provider' },
  { key: 'Sub Specialty Service Required For Patient', value: 'sub_specialty_service_required_for_patient' },
  { key: 'Out of Network Provider', value: 'out_of_network_provider' },
  { key: 'Requires PCP Referral', value: 'requires_pcp_referral' },
  { key: 'Other', value: 'other' },
];
